module.exports = __webpack_public_path__ + "static/media/bus-model-modern-svgrepo-com.d403ef64.svg";